<template>
    <!-- <label>{{$props.context.label}}</label> -->
    <div class="formTree">
        <!-- <Tree
            :nodes="tree.nodes"
            :config="tree.config"
            @nodeFocus="treeClick"
            ></Tree> -->

            <multiselect v-if="isAsync"
                v-model="selectedValue"
                :options="asyncOptions"
                label="name"
                track-by="id"
                placeholder=""
                :show-no-options="false"
                @search-change="search"
                :multiple="false">
                :custom-label="customLabel"
                <template #singleLabel="props">
                    <span v-html="getAsyncSingleHtml(props.option)"></span>
                </template>
                <template #option="props">
                    <span v-html="getAsyncOptionHtml(props.option)"></span>
                </template>
                </multiselect>

            <multiselect v-else
                v-model="selectedValue"
                :options="options"
                label="name"
                track-by="id"
                placeholder=""
                :show-no-options="false"
                
                :multiple="false">
                </multiselect>

    </div>
</template>

<script>
  import Multiselect from 'vue-multiselect'
  import "vue-multiselect/dist/vue-multiselect.css";
import { ref } from 'vue';

export default {
  components: {Multiselect},
  props: {
      context: {
          type:Object,
          required:true
      },
    //   nodes: {
    //       type:Object,
    //       required:true
    //   }
  },
  data() {
      return {
        selectedValue:false,
        asyncOptions:[],
        
        // options:[
        //     // {id:1, name:'pietje'},
        //     // {id:2, name:'klaasje'},
        //     // {id:3, name:'jantje'},
        //     // {id:4, name:'sjakie'},
        //     // {id:5, name:'harrie'},
            
        // ],
      }
  },
  methods: {
      customLabel ({title, desc}) {
        return `${title} – ${desc}`
      },
      getAsyncSingleHtml(option) {
        //console.log('getAsyncSingleHtml', option, this.context)
        if (this.context.attrs.singleLabelHtmlFunction) return this.context.attrs.singleLabelHtmlFunction(option);
        return option.name;
      },
      getAsyncOptionHtml(option) {
        //console.log('getAsyncOptionHtml', option, this.context)
        if (this.context.attrs.optionHtmlFunction) return this.context.attrs.optionHtmlFunction(option);
        return option.name;
      },
      handleInput(e) {
          //console.log('handleInput', e)
            //this.$props.context.node.input(e.level.content)

      },
      async search(e) {
        //return;
          if (!this.isAsync) return;
          //console.log('search', e, this.$props)

          // Clear any existing timer
          if (this.searchTimer) {
              clearTimeout(this.searchTimer);
          }

          // Set new timer
          this.searchTimer = setTimeout(async () => {
              if (this.$props.context.attrs.asyncEndpoint) {
                  const res = await this.callApi('post', this.$props.context.attrs.asyncEndpoint, {query:e});
                  this.asyncOptions = res.data.result;
              }
          }, 300);

        //   return;
        //   const res = await this.callApi('post', '/search', {search:e});
        //   console.log(res.data.result)
        //   this.options = res.data.result;
      },
      
  },
  computed: {
    isAsync() {
        //console.log('isAsync', this.$props.context.attrs.async)
        return this.$props.context.attrs.async;
    },
    options() {
        if (this.isAsync) return this.asyncOptions;
        let a = [];
        this.$props.context.attrs.options.forEach(option=>{
            a.push({id:option.value, name:option.label});
        })
        //let test = a.find(o=>o.id==this.$props.context._value);

        return a;
    },
    value() {
        return this.selectedValue;
        // var a = [];
        // this.selectedValue.forEach(id=>{
        //     a.push({id:id, name: this.options.find(o=>o.id==id).name})
        // })
        // return a;
    }
  },
  watch: {
    'context._value': function(newVal) {

        console.log('watch _value', newVal)
        let newOption = false;

        if (this.isAsync) {
            this.asyncOptions.forEach(option=>{
                if (option.value == newVal) newOption = {id:option.value, name:option.label};
            })

        }
        else {
            this.$props.context.attrs.options.forEach(option=>{
                if (option.value == newVal) newOption = {id:option.value, name:option.label};
            })

        }
        if (newOption) this.selectedValue = newOption;
        //this.selectedValue = this.options.find(o=>o.id==newVal);
    },
    value(newVal) {
        console.log('watch value', newVal, this.selectedValue)
        //this.$props.context.node.input(newVal);
    },
    selectedValue(newVal) {
        //console.log('watch', newVal, this.selectedValue)
          this.valueCopy = newVal;
          var a = [];
          if (this.selectedValue && this.selectedValue.id) {
              this.$props.context.node.input(this.selectedValue.id);
          }
          else {
              this.$props.context.node.input(false);
          }
          //this.$props.context.node.input(this.selectedValue.id);
      }
      // context(newVal) {
      //     this.valueCopy = newVal;
      // }
  },
  created() {
        //console.log('autocomplete created', this.$props.context._value)
        
        if (!this.$props.context._value || this.$props.context._value == undefined)    return;
        
            this.selectedValue = this.options.find(o=>o.id==this.$props.context._value);

  },
  beforeMount() {
        //console.log('autocomplete beforeMount', this.$props)
        // this.$props.context.attrs.options.forEach(option=>{
        //     this.options.push({id:option.value, name:option.label});
        // })

  },
  beforeUnmount() {
        //console.log('autocomplete beforeUnmount', this.$props.context._value)
        // this.autocomplete.nodes = {};
        // this.autocomplete.config.roots = [];
        // this.autocomplete.config.leaves = [];
        // this.$props.context.attrs.nodes =[]
  },
  mounted() {
        //console.log('autocomplete mounted', this.$props.context._value)
        //debugger;
        
  }
}
// const props = defineProps({
//     context: Object,
// })
// console.log(props)
// var testval = ref(props.context.value)
// function handleInput(e) {
//     console.log(props)
//     console.log(e)
//     testval = e.level.content
//     //props.context.node.input(e.target.value)
//     //props.context.node.input(e.level.content)
//     //props.context.node.input('234')
// }

</script>


<style>
.formkit-outer[data-type="autocomplete"] .multiselect__input {
    border:none !important;
}
.formkit-outer[data-type="autocomplete"] .multiselect__tags  {
    background-color:var(--cell-bg-color);
}
.formkit-outer[data-type="autocomplete"][data-empty=true] .multiselect__tags {
    padding: 1.20rem 4.2rem 1.60rem 1.8rem;
}
.formkit-outer[data-type="autocomplete"] .multiselect--active .multiselect__tags {
    padding: 0 !important;
    margin: 0 !important;
}
.formkit-outer[data-type="autocomplete"] .multiselect--active .multiselect__input {
    margin-bottom:0 !important
}
.formkit-outer[data-type="autocomplete"][data-complete=true] .multiselect__tags {
    padding: 1rem 4.2rem 0.4rem 1.8rem;
}
.formkit-outer[data-type="autocomplete"][data-complete=true] .multiselect__single {
    font-size: inherit;
    background: inherit;
}
</style>